import type { ReactNode } from "react";
import "./BadgeGroup.scss";

type BadgeGroupProps = {
  children?: ReactNode;
};

export const BadgeGroup = ({ children }: BadgeGroupProps) => {
  return <div className="badge-group">{children}</div>;
};
